import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { PageRoutes } from "../../../constants/routes";
import { AuthPasskeyChallengeRegisterResponse } from "../../../core/api/requests/auth/passkey_challenge_register/types";
import { appActions } from "../../../ducks/app";
import { authActions } from "../../../ducks/auth";
import { useNavigation } from "../../../hooks/useNavigation";
import { useWebAuthn } from "../../../hooks/useWebAuthn";
import { AppDispatch } from "../../../store";

export const usePasskeySetting = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { navigateToPage } = useNavigation();
  const { registration } = useWebAuthn();
  const { state } = useLocation();
  const {
    accessToken,
    payload,
  }: { payload: AuthPasskeyChallengeRegisterResponse; accessToken: string } =
    state ?? {};

  useEffect(() => {
    if (!accessToken) return navigateToPage(PageRoutes.LOGIN);
    (async () => {
      try {
        dispatch(appActions.showLoading());
        const result = await registration(payload);
        const response = result.response;
        dispatch(
          authActions.registerPasskey.started({
            passkey_token: payload.passkey_token,
            credential: {
              id: result.id,
              type: result.type,
              raw_id: result.rawId,
              response: {
                attestation_object: response.attestationObject,
                client_data_json: response.clientDataJSON,
                authenticator_data: response.authenticatorData,
                public_key: response.publicKey,
                transports: response.transports,
              },
              authenticator_attachment: result.authenticatorAttachment,
            },
            onComplete: () => dispatch(appActions.hideLoading()),
            onSuccess: ({ success }) => {
              if (!success) navigateToPage(PageRoutes.LOGIN);
              else
                navigateToPage(PageRoutes.PASSKEY_SETTING_COMPLETE, false, {
                  accessToken,
                });
            },
          }),
        );
      } catch (error) {
        dispatch(appActions.hideLoading());
        dispatch(
          appActions.showModal({
            title: "パスキーを設定できませんでした",
            buttons: [],
            onDefaultCloseModal: () => {
              navigateToPage(PageRoutes.EASY_LOGIN, false, { accessToken });
            },
          }),
        );
      }
    })();
  }, [accessToken]);

  return {};
};
